module.exports = __webpack_public_path__ + "static/media/lottery.d6d93c53.png";